import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Globe, Mail, Phone, Share2, X } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ShareMenu = ({ company, onClose }) => {
  const url = window.location.href;
  const text = `${company.name} — Award-winning ${company.title || 'company'} recognized by World Financial Award`;

  const share = (platform) => {
    const urls = {
      twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
      whatsapp: `https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`,
      telegram: `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
    };
    window.open(urls[platform], '_blank', 'width=600,height=400');
    onClose();
  };

  const copyLink = () => {
    navigator.clipboard.writeText(url);
    onClose();
  };

  return (
    <div className="share-dropdown" data-testid="share-dropdown">
      <button className="share-option" onClick={() => share('twitter')} data-testid="share-twitter">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
        X / Twitter
      </button>
      <button className="share-option" onClick={() => share('facebook')} data-testid="share-facebook">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
        Facebook
      </button>
      <button className="share-option" onClick={() => share('linkedin')} data-testid="share-linkedin">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
        LinkedIn
      </button>
      <button className="share-option" onClick={() => share('whatsapp')} data-testid="share-whatsapp">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
        WhatsApp
      </button>
      <button className="share-option" onClick={() => share('telegram')} data-testid="share-telegram">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>
        Telegram
      </button>
      <button className="share-option" onClick={copyLink} data-testid="share-copy-link">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
        Copy Link
      </button>
    </div>
  );
};

const CompanyDetail = () => {
  const { slug } = useParams();
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showShare, setShowShare] = useState(false);

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const res = await fetch(`${API_URL}/api/companies/slug/${slug}`);
        if (!res.ok) throw new Error('Company not found');
        setCompany(await res.json());
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchCompany();
  }, [slug]);

  if (loading) return <div className="company-page compact"><div className="company-container"><div className="loading-state">Loading...</div></div></div>;
  if (error) return <div className="company-page compact"><div className="company-container"><div className="error-state">Company not found. <Link to="/hall-of-fame">Back to Hall of Fame</Link></div></div></div>;
  if (!company) return null;

  const sortedAwards = [...(company.awards || [])].sort((a, b) => parseInt(b.year) - parseInt(a.year));

  const isHtml = (str) => /<[a-z][\s\S]*>/i.test(str);

  const plainToHtml = (text) => {
    let html = text
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/(https?:\/\/[^\s)<]+)/g, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>')
      .replace(/\n\s*\n/g, '</p><p>')
      .replace(/\n/g, '<br/>');
    return `<p>${html}</p>`;
  };

  const descriptionHtml = company.description && company.description !== 'TBA'
    ? (isHtml(company.description) ? company.description : plainToHtml(company.description))
    : null;

  return (
    <div className="company-page compact" data-testid="company-detail-page">
      <div className="company-container">
        <div className="company-top-bar">
          <Link to="/hall-of-fame" className="back-link" data-testid="back-to-hof">
            <ArrowLeft size={16} /> Hall of Fame
          </Link>
          <div className="share-wrapper">
            <button className="share-btn" onClick={() => setShowShare(!showShare)} data-testid="share-btn">
              {showShare ? <X size={16} /> : <Share2 size={16} />}
              <span>Share</span>
            </button>
            {showShare && <ShareMenu company={company} onClose={() => setShowShare(false)} />}
          </div>
        </div>

        <div className="company-header compact">
          <div className="company-logo-large">
            {company.logo ? (
              <img src={company.logo} alt={company.name} />
            ) : (
              <div className="logo-placeholder-large">{company.name?.charAt(0)}</div>
            )}
          </div>
          <div className="company-info">
            <h1 className="company-name-title" data-testid="company-name">{company.name}</h1>
            {company.title && <span className="company-type-badge">{company.title}</span>}
            <div className="company-meta">
              {company.website && (
                <a href={company.website} target="_blank" rel="noopener noreferrer" className="company-link" data-testid="company-website">
                  <Globe size={13} /> Website
                </a>
              )}
              {company.email && <span className="company-email"><Mail size={13} /> {company.email}</span>}
              {company.phone && <span className="company-phone"><Phone size={13} /> {company.phone}</span>}
            </div>
          </div>
        </div>

        {sortedAwards.length > 0 && (
          <div className="company-awards compact" data-testid="company-awards">
            <h2>Awards ({sortedAwards.length})</h2>
            <div className="awards-grid compact">
              {sortedAwards.map((award, idx) => (
                <div key={idx} className="award-card compact" data-testid={`award-card-${idx}`}>
                  {award.award_image && (
                    <div className="award-image-wrap compact">
                      <img src={award.award_image} alt={award.nomination} />
                    </div>
                  )}
                  <div className="award-info compact">
                    <span className="award-year-badge">{award.year}</span>
                    <h3 className="award-nomination">{award.nomination}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {descriptionHtml && (
          <div className="company-description" data-testid="company-description">
            <h2>About</h2>
            <div className="rich-text-content" dangerouslySetInnerHTML={{ __html: descriptionHtml }} />
          </div>
        )}
      </div>
    </div>
  );
};

export default CompanyDetail;
